import { usePermissions } from './usePermissions';
import { CAPABILITY_REASONS } from '/src/features/_global/constants';

export function useHasFeatureAccess(feature) {
  const permissions = usePermissions();

  const canView = permissions.can('view', feature);
  if (canView.allowed === true) {
    return true;
  } else if (canView.reason === CAPABILITY_REASONS.PERMISSION_UNDEFINED) {
    const canEdit = permissions.can('edit', feature);
    if (canEdit.allowed === true) {
      return true;
    }
  }
  return false;
}
